import CalendarContext from '@/context/CalendarContext';
import { CalendarAttributes, StrapiEntry } from '@/lib/apiTypes';
import { useContext } from 'react';

const useCalendar = () => useContext(CalendarContext);

export type MonthlyCalendarEntry = {
	month: number;
	year: number;
	displayName: string;
	entries: StrapiEntry<CalendarAttributes>[];
	dates: Date[];
};

export default useCalendar;
